// Provides the ability to specify multiple guards for vue routes
// Based on https://github.com/atanas-angelov-dev/vue-router-multiguard

const evaluateGuards = (guards, to, from, next) => {
  if (!guards.length) {
    next();
    return;
  }

  const [nextGuard, ...guardsLeft] = guards;

  nextGuard(to, from, (nextArg) => {
    if (typeof nextArg === 'undefined') {
      evaluateGuards(guardsLeft, to, from, next);
      return;
    }

    next(nextArg);
  });
};

export default (guards = []) => {
  if (!Array.isArray(guards)) {
    throw new TypeError('You must specify an array of guards');
  }

  return (to, from, next) => {
    const nextFn = typeof next === 'function' ? next : () => {};

    evaluateGuards(guards, to, from, nextFn);
  };
};
